import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { get, post, put, deleteFetch } from "config/fetch";
import { baseURL } from "constants/baseUrl";
import * as queryKeys from "utils/queryKeys";

export const useGetProfileQuery = (options) =>
  useQuery({
    queryFn: () => get(`${baseURL}/settings/profile`),
    queryKey: [queryKeys.Settings],
    select: (data) => data?.data.profile,
    ...options,
  });

export const usePasswordChangeMutation = (options) =>
  useMutation({
    mutationFn: (data) => put(`${baseURL}/settings/profile/password`, { data }),
    ...options,
  });

export const useInitiateTwoFaSetup = (options) => {
  const query = useQueryClient();
  return useMutation({
    mutationFn: (data) => put(`${baseURL}/settings/2fa`, { data }),
    ...options,
    onSuccess: async () => {
      await query.invalidateQueries({ queryKey: [queryKeys.Settings] });
      options?.onSuccess();
    },
  });
};

export const useVerifyTwoFaSetup = (options) => {
  const query = useQueryClient();
  return useMutation({
    mutationFn: (data) => post(`${baseURL}/settings/2fa/verify`, { data }),
    ...options,
    onSuccess: async () => {
      await query.invalidateQueries({ queryKey: [queryKeys.Settings] });
      options?.onSuccess();
    },
  });
};

export const useRequestTwoFaOtp = (options) =>
  useMutation({
    mutationFn: (data) => post(`${baseURL}/account/request-2fa-otp`, { data }),
    ...options,
  });

export const useDisableTwoFa = (options) => {
  const query = useQueryClient();

  return useMutation({
    mutationFn: (data) => deleteFetch(`${baseURL}/settings/2fa`, { data }),
    ...options,
    onSuccess: async () => {
      await query.invalidateQueries({ queryKey: [queryKeys.Settings] });
      options?.onSuccess();
    },
  });
};
